import {
    // Education
    GraduationCap, BookOpen, Book, School, Library, NotebookPen, PencilRuler, Languages, Microscope,
    FlaskConical, Atom, BrainCircuit, Brain, Lightbulb, FileText, ClipboardList, Award, Medal,
    Trophy, Star, BadgeCheck, FileBadge,
    // People
    Users, UserRound, UserCheck, Baby, PersonStanding, HandHeart, Handshake, Heart, HeartPulse,
    // Business
    Briefcase, Building2, Building, Landmark, Store, Wallet, CreditCard, Banknote,
    CircleDollarSign, TrendingUp, BarChart3, PieChart, Target, Rocket, Gem,
    // Tech
    Code, Laptop, Monitor, Smartphone, Tablet, Cpu, Globe, Wifi, Cloud, Server,
    Database, Shield, ShieldCheck, Lock, Key, Fingerprint, QrCode, Binary,
    // Communication
    Mail, MessageCircle, MessageSquare, Phone, Video, Megaphone, Bell, Send, Share2, Rss,
    // Media
    Camera, Image, Film, Music, Play, Headphones, Mic, Palette, Brush, PenTool,
    // Navigation & Location
    MapPin, Map, Navigation, Compass, Home, Flag, Signpost,
    // Time & Calendar
    Clock, Timer, Calendar, CalendarDays, CalendarCheck, Hourglass, AlarmClock,
    // Nature & Weather
    Sun, Moon, CloudSun, Leaf, TreePine, Flower2, Mountain, Waves, Droplets, Snowflake, Wind, Zap,
    // Health & Sports
    Dumbbell, Bike, Activity, Stethoscope, Pill, Syringe, Apple, HeartHandshake,
    // Transport
    Car, Bus, Plane, Ship, Train,
    // Tools & Objects
    Wrench, Settings, Hammer, Scissors, Search, Eye, Download, Upload, Link, Paperclip,
    Printer, Package, Box, Archive, FolderOpen, Save, Trash2, RefreshCw, RotateCw,
    // Arrows & UI
    ArrowRight, ArrowUp, ArrowDown, ChevronRight, Check, CheckCircle, CheckCircle2,
    CircleAlert, Info, HelpCircle, XCircle, Plus, Minus, X,
    // Food & Lifestyle
    Coffee, UtensilsCrossed, Wine, ShoppingCart, ShoppingBag, Shirt, Gift,
    // Misc
    Sparkles, Flame, Crown, Anchor, Puzzle, Blocks, Shapes, SquareStack, Layers, Grid3x3,
    Gauge, Power, PlugZap, CircuitBoard, Terminal, GitBranch, FileCode,
} from 'lucide-react';

const ICON_MAP = {
    // Education
    'graduation-cap': GraduationCap, 'graduation': GraduationCap,
    'book-open': BookOpen, 'book': Book,
    'school': School, 'library': Library,
    'notebook-pen': NotebookPen, 'pencil-ruler': PencilRuler,
    'languages': Languages, 'microscope': Microscope,
    'flask-conical': FlaskConical, 'atom': Atom,
    'brain-circuit': BrainCircuit, 'brain': Brain,
    'lightbulb': Lightbulb, 'file-text': FileText,
    'clipboard-list': ClipboardList, 'award': Award,
    'medal': Medal, 'trophy': Trophy,
    'star': Star, 'badge-check': BadgeCheck, 'certificate': FileBadge,
    // People
    'users': Users, 'user-round': UserRound, 'user-check': UserCheck,
    'baby': Baby, 'person-standing': PersonStanding,
    'hand-heart': HandHeart, 'handshake': Handshake,
    'heart': Heart, 'heart-pulse': HeartPulse,
    // Business
    'briefcase': Briefcase, 'building-2': Building2, 'building': Building,
    'landmark': Landmark, 'store': Store,
    'wallet': Wallet, 'credit-card': CreditCard, 'banknote': Banknote,
    'circle-dollar-sign': CircleDollarSign, 'trending-up': TrendingUp,
    'bar-chart-3': BarChart3, 'pie-chart': PieChart,
    'target': Target, 'rocket': Rocket, 'gem': Gem,
    // Tech
    'code': Code, 'laptop': Laptop, 'monitor': Monitor,
    'smartphone': Smartphone, 'tablet': Tablet, 'cpu': Cpu,
    'globe': Globe, 'wifi': Wifi, 'cloud': Cloud,
    'server': Server, 'database': Database,
    'shield': Shield, 'shield-check': ShieldCheck,
    'lock': Lock, 'key': Key, 'fingerprint': Fingerprint,
    'qr-code': QrCode, 'binary': Binary,
    // Communication
    'mail': Mail, 'message-circle': MessageCircle, 'message-square': MessageSquare,
    'phone': Phone, 'video': Video, 'megaphone': Megaphone,
    'bell': Bell, 'send': Send, 'share-2': Share2, 'rss': Rss,
    // Media
    'camera': Camera, 'image': Image, 'film': Film,
    'music': Music, 'play': Play, 'headphones': Headphones,
    'mic': Mic, 'palette': Palette, 'brush': Brush, 'pen-tool': PenTool,
    // Navigation
    'map-pin': MapPin, 'map': Map, 'navigation': Navigation,
    'compass': Compass, 'home': Home, 'flag': Flag, 'signpost': Signpost,
    // Time
    'clock': Clock, 'timer': Timer, 'calendar': Calendar,
    'calendar-days': CalendarDays, 'calendar-check': CalendarCheck,
    'hourglass': Hourglass, 'alarm-clock': AlarmClock,
    // Nature
    'sun': Sun, 'moon': Moon, 'cloud-sun': CloudSun,
    'leaf': Leaf, 'tree-pine': TreePine, 'flower-2': Flower2,
    'mountain': Mountain, 'waves': Waves, 'droplets': Droplets,
    'snowflake': Snowflake, 'wind': Wind, 'zap': Zap,
    // Health
    'dumbbell': Dumbbell, 'bike': Bike, 'activity': Activity,
    'stethoscope': Stethoscope, 'pill': Pill, 'syringe': Syringe,
    'apple': Apple, 'heart-handshake': HeartHandshake,
    // Transport
    'car': Car, 'bus': Bus, 'plane': Plane, 'ship': Ship, 'train': Train,
    // Tools
    'wrench': Wrench, 'settings': Settings, 'hammer': Hammer, 'scissors': Scissors,
    'search': Search, 'eye': Eye, 'download': Download, 'upload': Upload,
    'link': Link, 'paperclip': Paperclip, 'printer': Printer,
    'package': Package, 'box': Box, 'archive': Archive,
    'folder-open': FolderOpen, 'save': Save, 'trash-2': Trash2,
    'refresh-cw': RefreshCw, 'rotate-cw': RotateCw,
    // Arrows & UI
    'arrow-right': ArrowRight, 'arrow-up': ArrowUp, 'arrow-down': ArrowDown,
    'chevron-right': ChevronRight,
    'check': Check, 'check-circle': CheckCircle, 'check-circle-2': CheckCircle2,
    'circle-alert': CircleAlert, 'info': Info, 'help-circle': HelpCircle,
    'x-circle': XCircle, 'plus': Plus, 'minus': Minus, 'x': X,
    // Food & Lifestyle
    'coffee': Coffee, 'utensils-crossed': UtensilsCrossed, 'wine': Wine,
    'shopping-cart': ShoppingCart, 'shopping-bag': ShoppingBag,
    'shirt': Shirt, 'gift': Gift,
    // Misc
    'sparkles': Sparkles, 'flame': Flame, 'crown': Crown,
    'anchor': Anchor, 'puzzle': Puzzle, 'blocks': Blocks,
    'shapes': Shapes, 'square-stack': SquareStack, 'layers': Layers,
    'grid-3x3': Grid3x3, 'gauge': Gauge, 'power': Power,
    'plug-zap': PlugZap, 'circuit-board': CircuitBoard,
    'terminal': Terminal, 'git-branch': GitBranch, 'file-code': FileCode,
    // Legacy aliases
    'lightning': Zap, 'chart': BarChart3,
};

// Catalog with categories and Spanish labels — used by IconPicker
export const ICON_CATALOG = [
    { cat: 'Educacion', items: [
        {name:'graduation-cap',label:'Graduacion'},{name:'book-open',label:'Libro abierto'},{name:'book',label:'Libro'},
        {name:'school',label:'Escuela'},{name:'library',label:'Biblioteca'},{name:'notebook-pen',label:'Cuaderno'},
        {name:'pencil-ruler',label:'Regla y lapiz'},{name:'languages',label:'Idiomas'},{name:'microscope',label:'Microscopio'},
        {name:'flask-conical',label:'Matraz'},{name:'atom',label:'Atomo'},{name:'brain-circuit',label:'Neuro IA'},
        {name:'brain',label:'Cerebro'},{name:'lightbulb',label:'Foco'},{name:'file-text',label:'Documento'},
        {name:'clipboard-list',label:'Lista'},{name:'award',label:'Premio'},{name:'medal',label:'Medalla'},
        {name:'trophy',label:'Trofeo'},{name:'star',label:'Estrella'},{name:'badge-check',label:'Verificado'},
        {name:'certificate',label:'Certificado'},
    ]},
    { cat: 'Personas', items: [
        {name:'users',label:'Grupo'},{name:'user-round',label:'Persona'},{name:'user-check',label:'Usuario ok'},
        {name:'baby',label:'Bebe'},{name:'person-standing',label:'Persona de pie'},
        {name:'hand-heart',label:'Voluntariado'},{name:'handshake',label:'Alianza'},
        {name:'heart',label:'Corazon'},{name:'heart-pulse',label:'Pulso'},
    ]},
    { cat: 'Negocios', items: [
        {name:'briefcase',label:'Maletin'},{name:'building-2',label:'Edificio'},{name:'building',label:'Oficina'},
        {name:'landmark',label:'Institucion'},{name:'store',label:'Tienda'},
        {name:'wallet',label:'Billetera'},{name:'credit-card',label:'Tarjeta'},{name:'banknote',label:'Billete'},
        {name:'circle-dollar-sign',label:'Dolar'},{name:'trending-up',label:'Tendencia'},
        {name:'bar-chart-3',label:'Grafico barras'},{name:'pie-chart',label:'Grafico torta'},
        {name:'target',label:'Objetivo'},{name:'rocket',label:'Cohete'},{name:'gem',label:'Gema'},
    ]},
    { cat: 'Tecnologia', items: [
        {name:'code',label:'Codigo'},{name:'laptop',label:'Laptop'},{name:'monitor',label:'Monitor'},
        {name:'smartphone',label:'Celular'},{name:'tablet',label:'Tablet'},{name:'cpu',label:'Procesador'},
        {name:'globe',label:'Globo'},{name:'wifi',label:'Wifi'},{name:'cloud',label:'Nube'},
        {name:'server',label:'Servidor'},{name:'database',label:'Base datos'},
        {name:'shield',label:'Escudo'},{name:'shield-check',label:'Seguridad'},
        {name:'lock',label:'Candado'},{name:'key',label:'Llave'},{name:'fingerprint',label:'Huella'},
        {name:'qr-code',label:'Codigo QR'},{name:'binary',label:'Binario'},
    ]},
    { cat: 'Comunicacion', items: [
        {name:'mail',label:'Correo'},{name:'message-circle',label:'Mensaje'},{name:'message-square',label:'Chat'},
        {name:'phone',label:'Telefono'},{name:'video',label:'Video'},{name:'megaphone',label:'Megafono'},
        {name:'bell',label:'Campana'},{name:'send',label:'Enviar'},{name:'share-2',label:'Compartir'},{name:'rss',label:'RSS'},
    ]},
    { cat: 'Multimedia', items: [
        {name:'camera',label:'Camara'},{name:'image',label:'Imagen'},{name:'film',label:'Pelicula'},
        {name:'music',label:'Musica'},{name:'play',label:'Reproducir'},{name:'headphones',label:'Audifonos'},
        {name:'mic',label:'Microfono'},{name:'palette',label:'Paleta'},{name:'brush',label:'Pincel'},{name:'pen-tool',label:'Pluma'},
    ]},
    { cat: 'Ubicacion', items: [
        {name:'map-pin',label:'Pin mapa'},{name:'map',label:'Mapa'},{name:'navigation',label:'Navegacion'},
        {name:'compass',label:'Brujula'},{name:'home',label:'Casa'},{name:'flag',label:'Bandera'},{name:'signpost',label:'Senal'},
    ]},
    { cat: 'Tiempo', items: [
        {name:'clock',label:'Reloj'},{name:'timer',label:'Temporizador'},{name:'calendar',label:'Calendario'},
        {name:'calendar-days',label:'Agenda'},{name:'calendar-check',label:'Fecha ok'},
        {name:'hourglass',label:'Reloj arena'},{name:'alarm-clock',label:'Alarma'},
    ]},
    { cat: 'Naturaleza', items: [
        {name:'sun',label:'Sol'},{name:'moon',label:'Luna'},{name:'cloud-sun',label:'Parcial'},
        {name:'leaf',label:'Hoja'},{name:'tree-pine',label:'Arbol'},{name:'flower-2',label:'Flor'},
        {name:'mountain',label:'Montana'},{name:'waves',label:'Olas'},{name:'droplets',label:'Gotas'},
        {name:'snowflake',label:'Nieve'},{name:'wind',label:'Viento'},{name:'zap',label:'Rayo'},
    ]},
    { cat: 'Salud y Deporte', items: [
        {name:'dumbbell',label:'Pesas'},{name:'bike',label:'Bicicleta'},{name:'activity',label:'Actividad'},
        {name:'stethoscope',label:'Estetoscopio'},{name:'pill',label:'Pastilla'},{name:'syringe',label:'Jeringa'},
        {name:'apple',label:'Manzana'},{name:'heart-handshake',label:'Apoyo'},
    ]},
    { cat: 'Transporte', items: [
        {name:'car',label:'Auto'},{name:'bus',label:'Bus'},{name:'plane',label:'Avion'},
        {name:'ship',label:'Barco'},{name:'train',label:'Tren'},
    ]},
    { cat: 'Herramientas', items: [
        {name:'wrench',label:'Llave'},{name:'settings',label:'Config.'},{name:'hammer',label:'Martillo'},
        {name:'scissors',label:'Tijeras'},{name:'search',label:'Buscar'},{name:'eye',label:'Ojo'},
        {name:'download',label:'Descarga'},{name:'upload',label:'Subir'},{name:'link',label:'Enlace'},
        {name:'paperclip',label:'Clip'},{name:'printer',label:'Impresora'},{name:'package',label:'Paquete'},
        {name:'box',label:'Caja'},{name:'archive',label:'Archivo'},{name:'folder-open',label:'Carpeta'},
        {name:'save',label:'Guardar'},{name:'refresh-cw',label:'Refrescar'},
    ]},
    { cat: 'Flechas y UI', items: [
        {name:'arrow-right',label:'Flecha der.'},{name:'arrow-up',label:'Flecha arriba'},{name:'arrow-down',label:'Flecha abajo'},
        {name:'chevron-right',label:'Chevron'},
        {name:'check',label:'Check'},{name:'check-circle',label:'Check ok'},
        {name:'circle-alert',label:'Alerta'},{name:'info',label:'Info'},{name:'help-circle',label:'Ayuda'},
        {name:'plus',label:'Mas'},{name:'minus',label:'Menos'},
    ]},
    { cat: 'Estilo de vida', items: [
        {name:'coffee',label:'Cafe'},{name:'utensils-crossed',label:'Cubiertos'},{name:'wine',label:'Copa'},
        {name:'shopping-cart',label:'Carrito'},{name:'shopping-bag',label:'Bolsa'},
        {name:'shirt',label:'Ropa'},{name:'gift',label:'Regalo'},
    ]},
    { cat: 'Varios', items: [
        {name:'sparkles',label:'Brillos'},{name:'flame',label:'Fuego'},{name:'crown',label:'Corona'},
        {name:'anchor',label:'Ancla'},{name:'puzzle',label:'Puzzle'},{name:'blocks',label:'Bloques'},
        {name:'shapes',label:'Formas'},{name:'layers',label:'Capas'},{name:'grid-3x3',label:'Grilla'},
        {name:'gauge',label:'Medidor'},{name:'power',label:'Energia'},{name:'plug-zap',label:'Enchufe'},
        {name:'circuit-board',label:'Circuito'},{name:'terminal',label:'Terminal'},
        {name:'git-branch',label:'Rama'},{name:'file-code',label:'Archivo codigo'},
    ]},
];

// Flat lookup for label by name
const _labelMap = {};
ICON_CATALOG.forEach(c => c.items.forEach(i => { _labelMap[i.name] = i.label; }));
export function getIconLabel(name) { return _labelMap[name] || name; }

export default function SectionIcon({ name, size = 24, color, className = '' }) {
    if (!name) return null;
    // Emoji support (non-ASCII first char or 1-2 chars)
    if (name.charCodeAt(0) > 127 || name.length <= 2) {
        return <span className={className} style={{ fontSize: size * 0.8 }}>{name}</span>;
    }
    const IconComponent = ICON_MAP[name];
    if (!IconComponent) {
        return <span className={className} style={{ fontSize: size * 0.8 }}>{name}</span>;
    }
    return <IconComponent size={size} color={color || 'currentColor'} strokeWidth={1.5} className={className} />;
}
